import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import { THEME_COLORS } from "constants/theme";
import TriggerMenuItem from "layouts/Flow Designer/components/TriggerMenuItem";
import { setExecuteSelectedTriggerId } from "redux/actions/flowDesigner/triggersActionCreator";
import { useDetermineShareFlowUserAccessType } from "hooks/useDetermineShareFlowUserAccessType";
import { TRIGGER_TYPES } from "constants/flowDesigner";
import useAllowEditWorkflow from "hooks/useAllowEditWorkflow";

const TitlebarTriggerListWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  backgroundColor: THEME_COLORS[theme.palette?.mode?.toUpperCase()].SECONDARY_BG,
  padding: "0.375rem 0.75rem",
  borderEndStartRadius: "9px",
  borderEndEndRadius: "9px",
  width: "290px !important"
}));

const TitlebarTriggerList = ({
  executeTriggersList = false,
  setNodeStartTriggerListOpen = Function(),
  ...rest
}) => {
  const { flowTriggers, executeSelectedTriggerId } = useSelector(
    (state) => state?.designer?.triggers
  );
  const { currentSavedFlow } = useSelector((state) => state.designer.flows);
  const { isReadOnlyAccess } = useDetermineShareFlowUserAccessType(currentSavedFlow?.id);
  const dispatch = useDispatch();
  const { allowEditWorkflow } = useAllowEditWorkflow();

  const handleExecuteFlowByTrigger = (triggerId) => {
    dispatch(setExecuteSelectedTriggerId(triggerId));
  };

  useEffect(() => {
    // if executeTriggersList is true, execute the flow with the selected trigger
    const executeButton = document.getElementById("btnExecuteFlow");
    if (executeButton && executeSelectedTriggerId) {
      executeButton.click();
      setNodeStartTriggerListOpen(false);
    }
  }, [executeSelectedTriggerId]);

  return (
    <TitlebarTriggerListWrapper className="titlebar-action-trigger-list-collapse" {...rest}>
      <List className="group-container-list" sx={{ width: "100%" }}>
        {flowTriggers
          ?.sortAlphabetical("label")
          .filter((trigger) => trigger.type !== TRIGGER_TYPES.SCHEDULE)
          .map((trigger) => {
            return (
              <TriggerMenuItem
                key={trigger.type}
                allowDescription
                isTitlebarAction
                trigger={trigger}
                executeTriggersList={executeTriggersList}
                handleExecuteFlowByTrigger={handleExecuteFlowByTrigger}
                customStyles={{ fontSize: "22px", minWidth: "40px" }}
                setNodeStartTriggerListOpen={setNodeStartTriggerListOpen}
                allowEditWorkflow={allowEditWorkflow(isReadOnlyAccess)}
              />
            );
          })}
      </List>
    </TitlebarTriggerListWrapper>
  );
};

export default TitlebarTriggerList;
